import script from "./site-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./site-form-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./site-form-drawer.vue?vue&type=style&index=0&id=46f67baa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f67baa"]])

export default __exports__